export var STORAGE;
(function (STORAGE) {
    STORAGE[STORAGE["local"] = 0] = "local";
    STORAGE[STORAGE["session"] = 1] = "session";
})(STORAGE || (STORAGE = {}));
//# sourceMappingURL=storage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-webstorage/dist/enums/storage.js
// module id = 159
// module chunks = 1